import React, { useState, useEffect } from 'react';
import { collection, onSnapshot } from 'firebase/firestore';
import { db } from './firebase';
import Navbar from './Components/Navbar';
import Footer from './Components/Footer';
import './Articulos.css';

function Articulos() {
  const [articulos, setArticulos] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'articles'), (snap) => {
      const data = snap.docs
        .map((d) => ({ id: d.id, ...d.data() }))
        .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
      setArticulos(data);
    });
    return () => unsub();
  }, []);

  if (selected) {
    return (
      <div className="Articulos">
        <Navbar />
        <main className="articulo-detail">
          <button className="btn-back" onClick={() => setSelected(null)}>
            <i className="fa-solid fa-arrow-left" /> Volver
          </button>
          <h1>{selected.titulo}</h1>
          <div className="articulo-meta-info">
            <span>{selected.autor || 'Anónimo'}</span>
            <span>{selected.fecha}</span>
          </div>
          <div className="articulo-body">
            {selected.contenido.split('\n').map((p, i) => <p key={i}>{p}</p>)}
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="Articulos">
      <Navbar />
      <main className="articulos-main">
        <div className="articulos-header">
          <h1>Artículos</h1>
        </div>

        {articulos.length === 0 ? (
          <div className="articulos-empty">
            <i className="fa-solid fa-newspaper" />
            <p>No hay artículos todavía.</p>
          </div>
        ) : (
          <div className="articulos-grid">
            {articulos.map((art) => (
              <div key={art.id} className="articulo-card" onClick={() => setSelected(art)}>
                <h2>{art.titulo}</h2>
                <div className="articulo-card-meta">
                  <span>{art.autor || 'Anónimo'}</span>
                  <span>{art.fecha}</span>
                </div>
                <p className="articulo-preview">
                  {art.contenido.slice(0, 150)}
                  {art.contenido.length > 150 ? '...' : ''}
                </p>
              </div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default Articulos;
